import { config } from "./constant.config";

export const messages = {
  ADD_EDIT_SUBSIDIARIES: {
    INVALID_SUBSIDIARIES_NAME: 'Please enter subsidiary name.',
    INVALID_SAP_ID: 'Please enter SAP id.',
    INVALID_ADDRESS: 'Please enter address.',
    INVALID_STATE: 'Please select state.',
    INVALID_CITY: 'Please select city.',
    SUCCESS_ADDED_SUBSIDIARIES: 'Subsidary added successfuly.',
    SUCCESS_DELETED_SUBSIDIARIES: ' Subsidary removed successfuly.',
    SUCCESS_EDITED_SUBSIDIARIES: 'Successfuly edit subsidiaries.',
  },
  FLEET_REGISTRATION: {
    SUCCESSREGISTRATION: 'You’ve successfully registered your fleet.',
    UPDATEREGISTRATION: 'You’ve successfully updated your fleet.',
    ERRORMESSAGE: 'Something went wrong, Please try again. If issue persists please email us on jktyre@trackwalkins.com.',
    ONCANCELCLICKTITLE: 'Are you sure you want to quit the registration process?',
    ONCANCELCLICKMESSAGE: "Please note that you'll lose all the progress if you quit the process now."
  },
  OFFTAKE_REGISTRATION: {
    SUCCESSADDOFFTAKENTERY: 'We have submitted your offtake entry for verification.',
    SUCCESSUPDATEOFFTAKENTERY: 'We have updated your offtake entry for verification.',
    ERRORMESSAGE: 'Something went wrong, Please try again. If issue persists please email us on jktyre@trackwalkins.com.',
    ONCANCELCLICKTITLE: 'Are you sure you want to quit the Add Offtake Entry process?',
    ONCANCELCLICKMESSAGE: "Please note that you'll lose all the progress if you quit the process now.",
    ALREADYEXISTINVOICE: "Offtake Entry of this Invoice Number is already exist."
  },
  COMMON: {
    ERROR_MESSAGE: 'Oops! Something went wrong, Please try again. If issue persists please email us on jktyre@trackwalkins.com.',
  },
  LOGIN: {
    INVALID_USER_NAME: 'User ID should not be empty',
    EMPTY_USER_NAME: 'User ID should not be empty',
    EMPTY_PASSWORD: 'Password should not be empty'
  },
  PROFILE: {
    EMPTY_EMAIL: 'Please enter Email Address.',
    INVALID_EMAIL: 'Please enter valid Email Address.',
    EMPTY_PHONE: "Please enter Owner's Phone Number.",
    INVALID_PHONE: 'Please enter valid Phone Number.',
    INVALID_GST: 'Please enter valid gstin.',
    INVALID_PAN: 'Please enter valid PAN.',
    EMPTY_PERSON_NAME: 'Please enter Contact Person Name.',
    INVALID_PERSON_NAME: 'Please enter valid Contact Person Name',
    EMPTY_DESIGNATION: 'Please enter Designation',
    INVALID_DESIGNATION: 'Please enter valid Designation',
    EMPTY_ALTERNATE_NO: 'Please enter Alternate Number',
    INVALID_ALTERNATE_NO: 'Please enter valid Alternate Number',
    EMPTY_ALTERNATE_EMAIL: 'Please enter Alternate Email Address',
    INVALID_ALTERNATE_EMAIL: 'Please enter valid Alternate Email Address',
    EMPTY_WHATSAPP_NO: 'Please enter Whatsapp Number.',
    INVALID_WHATSAPP_NO: 'Please enter valid WhatsApp Number.',
    EMPTY_BIRTHDATE: 'Please enter Birth Date.',
    INVALID_FACEBOOK: 'Please enter valid Facebook Page.',
    INVALID_INSTAGRAM: 'Please enter valid Instagram Page.',
    INVALID_WEBSITE: 'Please enter valid Website.',
  },
  UPDATE_PASSWORD: {
    EMPTY_CURRENT_PASSWORD: 'Current password should not be empty',
    INVALID_NEW_PASSWORD: 'Please enter valid password',
    EMPTY_NEW_PASSWORD: 'New password should not be empty',
    PASSWORD_NOT_MATCH: 'New password and confirm password should be same',
  },
  PRIMARY_REPORT: {
    REDIRECT_JK_Baadshah: 'Please click here to know about Last year (up to March’19) Baadshah Program Points.'
  },
  SALES_REPORT: {
    EMPTY_CUSTOMER: '* Please select customer',
    EMPTY_TYRE_DESCRIPTION: '* Please select tyre description',
    EMPTY_QUANTITY: '* Please enter quantity',
    EMPTY_DATE: '* Please select date'
  },
  LOGOUT: 'Do you want to Logout?',
  DELETE_SALES: 'Are you sure you want to delete sales entry?',
  REPORT: {
    NO_OFFTAKE_SUMMARY:
      "The offtake points summary is displayed for the completed quarter of the finacial year.",
  },
  ADD_EDIT_ADDRESS: {
    STATE: "Please enter state.",
    CITY: "Please enter city.",
    PINCODE: "Please enter pincode.",
    ADDRESS: "Please enter address.",
    EMAIL: "Please enter email.",
    MOBILE: "Please enter mobile number.",
  },
  WARRANTY_REGISTRATION: {
    DAILYLIMITCAR: `Sorry! The limit for maximum tyres in a single day for a vehicle is ${config.WARRANTY_REGISTRATION.CAR.DAILYTYRELIMIT}. It seems you are regstering more than ${config.WARRANTY_REGISTRATION.CAR.DAILYTYRELIMIT} tyres in a single day for the same vehicle. `,
    DAILYLIMITTWOWHEELER: `Sorry! The limit for maximum tyres in a single day for a vehicle is ${config.WARRANTY_REGISTRATION.TWOWHEELER.DAILYTYRELIMIT}. It seems you are regstering more than ${config.WARRANTY_REGISTRATION.TWOWHEELER.DAILYTYRELIMIT} tyres in a single day for the same vehicle. `,
    LAST6MONTHLIMITCAR: `Sorry you have already registered ${config.WARRANTY_REGISTRATION.CAR.LAST6MONTHTYRELIMIT} tyres in last 6 months for same vehicle. You can not register more than ${config.WARRANTY_REGISTRATION.CAR.LAST6MONTHTYRELIMIT} tyres for same vehicle in six month.`,
    LAST6MONTHLIMITTWOWHEELER: `Sorry you have already registered ${config.WARRANTY_REGISTRATION.TWOWHEELER.LAST6MONTHTYRELIMIT} tyres in last 6 months for same vehicle. You can not register more than ${config.WARRANTY_REGISTRATION.TWOWHEELER.LAST6MONTHTYRELIMIT} tyres for same vehicle in six months.`,
    INVALIDOTP:
      "Sorry the OTP you have entered is not correct. Please try again.",
    INVALIDNUMBER:
      "Sorry the NUMBER you have entered is not correct. Please try again.",
    ALREADYREGISTEREDVEHICLENUMBER:
      "You have already registered same vehicle before. Why don't you select the vehicle again and we will bring its information for you.",
    SUCCESSREGISTRATION:
      "Congratulations! You've successfully registered a customer for the warranty.",
    ERRORMESSAGE:
      "Oops! Something went wrong, Please try again. If issue persists please email us on newjkadvantage@trackwalkins.com.",
    ONCANCELCLICKTITLE:
      "Are you sure you want to quit the registration process?",
    ONCANCELCLICKMESSAGE:
      "Please note that you'll lose all the progress if you quit the process now.",
    SKUIDSANDTYRECOUNTNOTSAME:
      "The number of Tyre Description you have entered do not match with the number of Tyre(s) you have selected!",
  },
};